import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Link } from 'react-router-dom'
import { useCookieConsent } from '../contexts/CookieConsentContext'
import CookiePreferenceModal from './CookiePreferenceModal'

const CookieConsent = () => {
  const { hasConsent, acceptAll, rejectAll } = useCookieConsent()
  const [showModal, setShowModal] = useState(false)

  const handleManagePreferences = () => {
    setShowModal(true)
  }

  return (
    <>
      <AnimatePresence>
        {!hasConsent && (
          <motion.div
            initial={{ y: 100, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            exit={{ y: 100, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 shadow-lg z-50"
          >
            <div className="container-custom py-6">
              <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
                <div className="flex-1 text-left">
                  <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
                    We Value Your Privacy
                  </h3>
                  <p className="text-gray-700 dark:text-gray-300 text-sm mb-3">
                    We use cookies to enhance your browsing experience, analyze website traffic, and provide personalized content.
                    You can choose to accept all cookies or customize your preferences.
                  </p>
                  <Link
                    to="/privacy"
                    className="text-primary-600 dark:text-primary-400 hover:text-primary-700 dark:hover:text-primary-300 underline text-sm font-medium"
                  >
                    Read our Privacy Policy
                  </Link>
                </div>
                <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
                  <button
                    onClick={rejectAll}
                    className="px-5 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors duration-200"
                  >
                    Reject All
                  </button>
                  <button
                    onClick={handleManagePreferences}
                    className="px-5 py-2.5 text-sm font-medium text-primary-600 dark:text-primary-400 bg-primary-50 dark:bg-primary-900/30 hover:bg-primary-100 dark:hover:bg-primary-900/50 rounded-lg transition-colors duration-200"
                  >
                    Manage Preferences
                  </button>
                  <button
                    onClick={acceptAll}
                    className="px-5 py-2.5 text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 rounded-lg transition-colors duration-200"
                  >
                    Accept All
                  </button>
                </div>
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>

      <CookiePreferenceModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </>
  )
}

export default CookieConsent
